import React from 'react';
import styled from 'styled-components';

const ToggleDiv = styled.div`
    position: relative;
    display: inline-block;
    width: 44px;
    height: 22px;

    & input {
        opacity: 0;
        width: 0;
        height: 0;
    }
`;

const ToggleSpan = styled.span`
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #d9d9d9;
    transition: 0.4s;
    border-radius: 23px;

    :before {
        position: absolute;
        content: '';
        height: 18px;
        width: 18px;
        left: 2px;
        bottom: 2px;
        background-color: white;
        transition: 0.4s;
        border-radius: 16px;
    }

    input:checked + & {
        background-color: #577ce7;
    }
    input:focus + & {
        box-shadow: 0 0 1px #577ce7;
    }
    input:checked + &:before {
        transform: translateX(22px);
    }
`;

export const ToggleSwitch = ({ label, value, setValue }: { label: string; value: boolean; setValue: () => void }) => {
    return (
        <div style={{ display: 'flex' }}>
            <div style={{ flex: 1 }}>{label}</div>
            <ToggleDiv onClick={setValue}>
                <input type='checkbox' checked={value} readOnly />
                <ToggleSpan />
            </ToggleDiv>
        </div>
    );
};
